import F84Game from "../Game";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import BaseURL from "../utils/BaseURL";
import LoaderScene from "./LoaderScene";
import Fonts from "../utils/Fonts";
import InitialLoadUtils from "../utils/InitialLoadUtils";
import LoadBatchManager from "../core/LoadBatchManager";

export default class BootScene extends LoaderScene {
    loaded: boolean;

    preload(): void {
        console.log("preload");
        console.log(F84Game.Instance.locale);
        super.preload();

        // this.load.imageLoadType = "HTMLImageElement"; // quicker load, avoids additional blob requests
        this.load.crossOrigin = 'anonymous'; // required for loading cross origin avatars

        this.loadJson("strings", "./locale/strings.json", false);
        this.loadJson("gameConfig", "./assets/json/game-config.json", false);
        this.loadImage("rotateDevice", "./assets/images/system/orientation.png");

        this.load.webfont(Fonts.DefaultFont, Fonts.DefaultFont);
        this.load.webfont(Fonts.LunchBoxRegular, Fonts.LunchBoxRegular);

        F84Game.Instance.loadBatches.loadBatchesForScene(this, "BootScene");
    }

    create(): void {
        super.create();

        GameConfig.loadConfigFile(this.cache, "gameConfig");
        console.log(Strings.get("GameTitle"));
        this.next();
    }

    next(): void {
        InitialLoadUtils.hideInitialLoader();
        let startScene = GameConfig.get("startScene");
        this.game.scene.start("PreloaderScene", {
            destinationScene: startScene,
        });
        this.scene.stop(this.scene.key);
    }
}
